/* eslint-disable import/no-cycle */
import { getCookieValueUtils } from '../index-utils';

export function getCookieValue(name) {
  return getCookieValueUtils(name);
}

export function deleteCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
